var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0977 13.2951L18.0985 12.6416C17.4461 13.102 16.5516 13.1464 15.843 12.6824C15.843 12.6824 12.8004 10.6948 12.5196 10.5085C12.1847 10.2845 11.7671 10.2706 11.41 10.5028C11.0538 10.7346 8.07423 12.6824 8.07423 12.6824C7.36506 13.1464 6.47216 13.102 5.81823 12.6416L4.82055 13.2951C3.98339 13.8427 3.74803 14.9642 4.29513 15.8009C4.84223 16.6386 5.96429 16.8739 6.80145 16.3258L11.4471 13.2894C11.8131 13.0638 12.1109 13.0638 12.4722 13.2884L17.1158 16.3258C17.9535 16.8739 19.075 16.6386 19.6226 15.8009C20.1687 14.9642 19.9344 13.8427 19.0977 13.2951Z",
    fill: "#7CB142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6205 7.67133C11.7226 7.60837 11.8434 7.57275 11.9725 7.57275C12.0989 7.57275 12.2171 7.60733 12.3193 7.66824C12.5097 7.7823 14.533 9.12269 14.533 9.12269C15.2039 9.56088 16.0664 9.47211 16.6362 8.96011L17.7846 9.71262C18.4963 10.1766 18.6961 11.1309 18.231 11.8427C17.7655 12.5539 16.8122 12.7542 16.1005 12.2886C16.1005 12.2886 12.8014 10.1374 12.4808 9.95366C12.1603 9.76888 11.7815 9.76114 11.4522 9.95727C11.1848 10.1157 7.8171 12.2886 7.8171 12.2886C7.11207 12.7144 6.15155 12.5539 5.68652 11.8427C5.22149 11.1309 5.42123 10.1766 6.13245 9.71262L7.28187 8.96011C7.85116 9.47211 8.7131 9.56088 9.3851 9.12269C9.3851 9.12269 11.4207 7.79262 11.6205 7.67133Z",
    fill: "#528A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3574 7.12555L14.7909 8.72761C15.3736 9.108 16.1546 8.94387 16.5355 8.36168C16.9158 7.78 16.7522 6.99858 16.17 6.61716L12.3398 4.11136C12.0967 3.96323 11.8216 3.96323 11.5853 4.10929L7.74836 6.61716C7.16513 6.99858 7.00152 7.78 7.38191 8.36168C7.76384 8.94387 8.54371 9.108 9.12642 8.72761L11.5951 7.12452C11.7107 7.04813 11.8315 6.99445 11.9755 6.99445C12.1195 6.99445 12.2428 7.04813 12.3574 7.12555Z",
    fill: "#004711"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.572 18.3528L12.5813 15.0965C12.4233 14.8276 12.1931 14.6908 11.9588 14.6836C11.7245 14.6908 11.4938 14.8276 11.3358 15.0965L9.34512 18.3528C9.08706 18.7522 9.14796 19.3897 9.86022 19.3897H14.0569C14.7686 19.3897 14.83 18.7522 14.572 18.3528Z",
    fill: "#004711"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/신영증권-24.3c9f1b0bcb77b33de480973c2ebb0ed4.svg";
export { ForwardRef as ReactComponent };